import { render, staticRenderFns } from "./SportCompensationRequest.vue?vue&type=template&id=3aa8256f"
import script from "./SportCompensationRequest.vue?vue&type=script&lang=js"
export * from "./SportCompensationRequest.vue?vue&type=script&lang=js"
import style0 from "./SportCompensationRequest.vue?vue&type=style&index=0&id=3aa8256f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports